<template>
  <div class="free-trial-wrapper w-full h-full flex flex-col bg-opacity-75 items-center overflow-y-scroll bg-white relative">
    <i
      class="absolute pi pi-times bg-black bg-opacity-30 p-3 rounded-full text-white top-2 left-2 z-100 cursor-pointer"
      @click="$emit('close')"/>

    <div class="flex flex-col bg-[#DAC9FD] w-full flex-shrink">
      <img
        style="width: 100%; margin-bottom: -2.2rem;"
        alt=""
        src="../../../../assets/img/admin/free-trial.svg"
      />
    </div>
    <div class="flex flex-col px-4 w-full pt-8 h-full gap-4">
      <span
        class="text-3xl font-bold text-[#723BE3FF] text-start pe-4">איזה כיף שהתחלתם את תקופת הנסיון שלכם</span>
      <span class="text-base font-light text-[#723BE3FF] text-start -mt-2">אנחנו כאן כדי לתת לך את החוויה המלאה לניהול העסק. כל הפתרונות לעסק שלך במקום אחד, בצורה פשוטה ונוחה.</span>
      <div class="flex gap-2 items-center">
        <i class="pi pi-star-fill text-yellow-500 !text-xl me-2"/>
        <section>
          <span class="font-medium me-1">הכל כלול ללא הגבלה:</span>
          <span>ללא מגבלת תורים ולקוחות. בנוסף, 1000 הודעות מתנה!</span>
        </section>
      </div>
      <div class="flex gap-2 items-center">
        <i class="pi pi-star-fill text-yellow-500 !text-xl me-2"/>
        <section>
          <span class="font-medium me-1">הפיצ׳רים המיוחדים שלנו:</span>
          <span>חנות פיקאפ אונליין, רשימת המתנה, שוברים וקופונים ומועדון לקוחות</span>
        </section>
      </div>
      <div class="flex gap-2 items-center">
        <i class="pi pi-star-fill text-yellow-500 !text-xl me-2"/>
        <section>
          <span class="font-medium me-1">חיבור לתשלומים וחשבוניות:</span>
          <span>חיבור סליקה וחשבוניות, ואפשרות לגבות דמי ביטול ומקדמות</span>
        </section>
      </div>
      <div class="flex gap-4 mt-2 w-full">
        <div class="flex flex-col gap-1 flex-start border p-4 border-primary-500 text-sm rounded-3xl w-full">
          <span class="font-medium">#הכל_כלול חודשי</span>
          <span class="text-xs">₪120* / חודש</span>
          <span class="text-xs mt-3">חיוב מתחדש בכל חודש</span>
        </div>
        <div class="flex flex-col gap-1 flex-start border p-4 border-primary-500 text-sm rounded-3xl w-full relative">
         <div class="w-full flex justify-center absolute -top-4 right-0">
           <span class=" bg-green-400 text-white font-medium px-2 py-1 rounded-xl text-xs ">17% הנחה</span>
         </div>
          <span class="font-medium">#הכל_כלול שנתי</span>
          <span class="text-xs">₪100* / חודש</span>
          <span class="text-xs mt-3">חיוב חד פעמי של ₪1200</span>
        </div>
      </div>
      <span class="text-xs">*המחירים אינם כוללים מע״מ</span>
      <div class="bg-white py-4 w-full flex flex-col gap-2 pt-4 flex-none mt-auto">
        <app-button label="דברו איתנו" @click-event="talkToUs"/>
        <span class="text-center p-2 underline text-gray-500 md:cursor-pointer" @click="switchToFreePlan">
          תנו לי את המסלול החינמי
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {sendWhatsApp} from "@torim-app/utils";
import {AdminApi} from "@app/api/admin/admin-api";
import {useToast} from "vue-toastification";
import {AppButton} from '@torim-app/shared-components';
import { trackEvent } from '@app/composables/posthog';

const toast = useToast();

defineEmits(['close'])

trackEvent('trial_info_modal_shown');

const talkToUs = () => {
  trackEvent('trial_info_talk_to_us_clicked');
  sendWhatsApp('972559299380', 'היי, הגעתי דרך האפליקציה ואני אשמח לשמוע עוד על המסלול #הכל_כלול.')
}

const switchToFreePlan = () => {
  trackEvent('trial_info_switch_to_free_clicked');
  AdminApi.switchToFreePlan()
    .then(() => {
      window.location.reload()
    }).catch((e) => {
      toast.error('לא הצלחנו לעבור למסלול החינמי, נסו שוב או שלחו לנו הודעה!')
      console.log(e);
    });
}
</script>

<style lang="scss">
.free-trial-wrapper {
  font-family: 'Rubik', sans-serif;

}
</style>
